import { render, staticRenderFns } from "./JoiningPersonalDetails.vue?vue&type=template&id=2a6302da&scoped=true&"
import script from "./JoiningPersonalDetails.vue?vue&type=script&lang=js&"
export * from "./JoiningPersonalDetails.vue?vue&type=script&lang=js&"
import style0 from "./JoiningPersonalDetails.vue?vue&type=style&index=0&id=2a6302da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6302da",
  null
  
)

export default component.exports